module.exports = __webpack_public_path__ + "v1.2.5.20250227/img/web_icon.fe53802a.png";